export const stateName = 'closetPromotions';